import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

// `badBibleTabs` holds one doc per tab of Anthony's Bad Bible Google Sheet,
// written only by scripts/seedBadBible.js. The rules let Anthony's account read
// it and nobody write it, so a one-shot read is all the page needs: the data
// only changes when the seed runs again.
export const BAD_BIBLE_COLLECTION = 'badBibleTabs';

export async function loadBadBibleTabs() {
	const snap = await getDocs(collection(db, BAD_BIBLE_COLLECTION));
	return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
